import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3CustomInput from '@Uilib/h3CustomInput';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import { updateCfValueParent } from '@Components/Common/CustomFieldLine';
import './style.scss';

const CustomFieldV2 = ({
  customFields, formSubmitted, customInputChange, cfWrapperClassName, disableCase, isHorizontalUi, inputClassName,
  labelClassName, containerClassName, hideTitle, wrapperClassName, customClassName, isProductForm, match, isCarryForward, isUpdate
}) => {
  // const cfMap = {};
  // const recordCf = JSON.parse(JSON.stringify(customFields?.filter((item) => (item.visible && item.isActive))));
  // for (let i = 0; i < recordCf?.length; i++) {
  //   const cf = recordCf[i];
  //   cfMap[cf?.cfId] = cf;
  // }
  const isDocumentInUpdateState = match.url.includes('/update') || (isUpdate === true);
  const isDocumentIsCarryForwarding = isCarryForward;
  // Helper function to determine if the input should be disabled
  const shouldDisableField = (customField) => (
    disableCase
    || (isDocumentInUpdateState && customField.isEditable === false)
    || (isDocumentIsCarryForwarding && customField.isCarryForward === false)
  );
  const cfMap = {};
  const filteredFields = customFields?.filter((item) => item.visible && item.isActive) || [];

  filteredFields.forEach((cf) => {
    cfMap[cf.cfId] = cf;
  });
  return (
    <div className="cf_wrapper">
      {(!hideTitle && customFields?.filter((item) => (item.visible))?.length > 0) && (
        <div className="ant-col-md-24 ant-col-xs-24">
          <div className="cf__heading">Other Information</div>
        </div>
      )}
      <div className="ant-col-md-24 ant-col-xs-24">
        <div className={isHorizontalUi ? `cf_horizontal ${cfWrapperClassName || ''}` : cfWrapperClassName}>
          <div
            className="ant-row"
          >
            {customFields?.filter((item) => (item.visible && item.isActive && item?.fieldType?.toUpperCase() !== 'ATTACHMENT' && item?.fieldType?.toUpperCase() !== 'CHECKBOX' && item?.fieldType?.toUpperCase() !== 'TEXTAREA'))?.map((customField, index) => (
              (isProductForm && customField?.fieldName === 'MRP') ? null : (
                <React.Fragment key={customField?.cfId}>
                  <div key={customField?.cfId} className={wrapperClassName || 'ant-col-md-12 ant-col-xs-24'}>
                    <H3CustomInput
                      containerClassName={`orgInputContainer ${containerClassName || ''} ${(isHorizontalUi ? 'custom-field__wrapper' : ((index % 2 === 0 && !isProductForm) ? 'cf_input-right' : 'cf_input-left'))}`}
                      customClassName="pr_input_custom_field"
                      labelClassName={`orgFormLabel ${(isHorizontalUi && customClassName) ? 'pr_custom-field-input__label' : isHorizontalUi ? 'custom-field-input__label ' : ''}${labelClassName || ''}`}
                      inputClassName={`orgFormInput ${isHorizontalUi ? 'custom-field-input ' : ''}${inputClassName || ''}`}
                      inputErrorClassName="cf__input-error"
                      type={customField?.fieldType?.toUpperCase()}
                      required={customField?.isRequired}
                      label={customField?.fieldName}
                      options={customField?.defaultData?.length ? customField?.defaultData : []}
                      placeholder={customField?.placeholder}
                      onChange={(value) => {
                        if (isProductForm) {
                          updateCfValueParent(value, customField, customField?.fieldType?.toUpperCase(), customInputChange, cfMap, customField?.cfId);
                        } else {
                          customInputChange(value, customField?.cfId);
                        }
                      }}
                      value={customField?.fieldValue}
                      showError={formSubmitted && customField?.isRequired && !customField?.fieldValue}
                      disabled={shouldDisableField(customField)}
                      isHorizontalUi={isHorizontalUi}
                    />
                  </div>
                  {isHorizontalUi && <div key={customField?.cfId} className="ant-col-md-12" />}
                </React.Fragment>
              )))}

            {customFields?.filter((item) => (item.visible && item.isActive && (item?.fieldType?.toUpperCase() === 'ATTACHMENT' || item?.fieldType?.toUpperCase() === 'CHECKBOX' || item?.fieldType?.toUpperCase() === 'TEXTAREA')))?.map((customField, index) => (
              <Fragment key={customField?.cfId}>
                <div className="ant-col-md-12 ant-col-xs-24">
                  <H3CustomInput
                    containerClassName={`orgInputContainer ${containerClassName || ''} ${(isHorizontalUi ? 'custom-field__wrapper' : ((index % 2 === 0 && !isProductForm) ? 'cf_input-right' : 'cf_input-left'))}`}
                    labelClassName={`orgFormLabel ${isHorizontalUi ? 'custom-field-input__label ' : ''}${labelClassName || ''}`}
                    inputClassName={`orgFormInput ${isHorizontalUi ? 'custom-field-input ' : ''}${inputClassName || ''}`}
                    inputErrorClassName="cf__input-error"
                    type={customField?.fieldType?.toUpperCase()}
                    required={customField?.isRequired}
                    label={customField?.fieldName}
                    options={customField?.defaultData?.length ? customField?.defaultData : []}
                    placeholder={customField?.placeholder}
                    // onChange={(value) => customInputChange(value, customField?.cfId)}
                    // onChange={(value) => {
                    //   updateCfValueParent(value, customField, customField?.fieldType?.toUpperCase(), customInputChange, cfMap, customField?.cfId);
                    // }}
                    onChange={(value) => {
                      if (isProductForm) {
                        updateCfValueParent(value, customField, customField?.fieldType?.toUpperCase(), customInputChange, cfMap, customField?.cfId);
                      } else {
                        customInputChange(value, customField?.cfId);
                      }
                    }}
                    value={customField?.fieldValue}
                    showError={(formSubmitted && customField?.isRequired && !customField?.fieldValue) || (formSubmitted && customField?.isRequired && customField?.fieldType?.toUpperCase() === 'ATTACHMENT' && customField?.fieldValue?.length === 0)}
                    disabled={shouldDisableField(customField)}
                    isHorizontalUi={isHorizontalUi}
                  />
                </div>
                {isHorizontalUi && <div className="ant-col-md-12" />}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = () => ({

});

const mapDispatchToProps = (dispatch) => ({
});

CustomFieldV2.propTypes = {
  customFields: PropTypes.any,
  formSubmitted: PropTypes.any,
  customInputChange: PropTypes.any,
  cfWrapperClassName: PropTypes.any,
  disableCase: PropTypes.any,
  isHorizontalUi: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.any,
  containerClassName: PropTypes.any,
  hideTitle: PropTypes.bool,
  wrapperClassName: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomFieldV2));
